export class AlertType {
    success:string='success';
    error:string='error';
    warning:string='warning';
    info:string='info';
    question:string='question';
    constructor(){}
}
